// Supported currencies for multi-currency accounts and budget filtering.
// Keep this in sync with the `currency` column type in account.d.ts.
export const SUPPORTED_CURRENCIES: [string, string][] = [
  ['PEN', 'PEN – Peruvian Sol'],
  ['USD', 'USD – US Dollar'],
  ['EUR', 'EUR – Euro'],
];
